import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';

const initialState = Immutable({
  updating: false,
  error: false,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_BASIC_INFO.START: {
      return state.set('updating', true);
    }

    case actionTypes.UPDATE_BASIC_INFO.FAILURE: {
      const { error } = action.payload;
      return state.set('updating', false).set('error', error);
    }

    case actionTypes.UPDATE_BASIC_INFO.SUCCESS: {
      return state.set('updating', false).set('error', false);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/graphql/UpdateBasicInfo/reducer.js